var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 1C14.1661 1 15.8546 2.76645 15.8546 4.94548C15.8546 5.19756 15.8319 5.44665 15.7874 5.69017L21.4969 5.68972C21.8136 5.68972 22.0827 5.91988 22.152 6.23455L22.1667 6.33134L20.8219 22.2764C20.8539 22.6561 20.5924 22.9869 20.2415 23.0355L20.1521 23.0417H4.01458C3.65026 23.0417 3.35827 22.7401 3.34278 22.3701L3.34479 22.2764L2 6.33134C2.02784 6.00122 2.27064 5.74105 2.57635 5.69648L2.66979 5.68972L8.37937 5.69073C8.3348 5.44707 8.31207 5.1978 8.31207 4.94548C8.31207 2.76645 10.0005 1 12.0833 1ZM20.8801 7.09663H3.28571L4.74884 21.6348H19.4169L20.8801 7.09663ZM12.0833 2.40691C10.7432 2.40691 9.65686 3.54347 9.65686 4.94548C9.65686 5.20177 9.69297 5.4521 9.76296 5.69089L14.4038 5.69049C14.4738 5.45176 14.5098 5.20159 14.5098 4.94548C14.5098 3.54347 13.4234 2.40691 12.0833 2.40691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagicon);
export default __webpack_public_path__ + "static/media/bagicon.a82576a45916205e6ac8a4a91870a3ba.svg";
export { ForwardRef as ReactComponent };